import { render, staticRenderFns } from "./BulkSubmissionQueueDashboard.vue?vue&type=template&id=53ec8e51&"
import script from "./BulkSubmissionQueueDashboard.vue?vue&type=script&lang=js&"
export * from "./BulkSubmissionQueueDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports